module.exports = __webpack_public_path__ + "img/ip.211d92b2.png";